import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fv-header-container" }
const _hoisted_2 = { class: "fv-content" }
const _hoisted_3 = ["title", "onClick", "onDblclick", "onKeydown", "aria-label", "aria-selected"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "item-name" }

import { computed, onMounted, ref, watch, type Ref } from "vue";
import { Folder, FolderUp, Place } from "@wwtelescope/engine";
import { Thumbnail } from "@wwtelescope/engine-types";
import { FolderViewProps, ItemSelectionType } from "../types";


export default /*@__PURE__*/_defineComponent({
  __name: 'FolderView',
  props: {
    rootFolder: {},
    flexDirection: {},
    gap: { default: "5px" },
    backgroundColor: { default: "black" },
    thumbnailColor: { default: "white" },
    highlightColor: { default: "#1671e0" },
    textColor: { default: "white" },
    startExpanded: { type: Boolean, default: true }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const items: Ref<Thumbnail[] | null> = ref<Thumbnail[]>([]);
const lastSelectedItem: Ref<Thumbnail | null> = ref(null);


const props = __props;

const emit = __emit;

const expanded = ref(props.startExpanded);
function toggleExpanded() {
  expanded.value = !expanded.value;
}

function updateFolder(folder: Folder) {
  const folderItems = folder.get_children()?.filter(item => item instanceof Place) ?? [];
  items.value = folderItems;
  const firstItem = items.value.find((item) => (!(item instanceof Folder) || (item instanceof FolderUp)));
  if (firstItem) {
    selectItem(firstItem, "folder");
  }
}

function selectItem(item: Thumbnail, type: ItemSelectionType) {
  lastSelectedItem.value = item;
  if (item instanceof Folder || item instanceof FolderUp) {
    items.value = item.get_children();
  }

  emit("select", { item, type });
}

onMounted(() => {
  updateFolder(props.rootFolder);
});

watch(() => props.rootFolder, updateFolder);

const cssVars = computed(() => ({
  "--flex-direction": props.flexDirection,
  "--background-color": props.backgroundColor,
  "--thumbnail-color": props.thumbnailColor,
  "--highlight-color": props.highlightColor,
  "--text-color": props.textColor,
  "--gap": props.gap,
}));

return (_ctx: any,_cache: any) => {
  return (items.value !== null)
    ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: "fv-root",
        style: _normalizeStyle(cssVars.value),
        "aria-role": "navigation",
        "aria-label": "Available Locations"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header", {
            expanded: expanded.value,
            toggleExpanded: toggleExpanded
          })
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['item', lastSelectedItem.value === item ? 'selected' : '']),
              key: item.get_name(),
              title: item.get_name(),
              onClick: () => selectItem(item, 'click'),
              onDblclick: () => selectItem(item, 'dblclick'),
              onKeydown: _withKeys(() => selectItem(item, 'keyup'), ["enter"]),
              tabindex: "0",
              role: "button",
              "aria-label": item.get_name(),
              "aria-selected": lastSelectedItem.value === item
            }, [
              _createElementVNode("img", {
                src: item.get_thumbnailUrl(),
                alt: item.get_name()
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.get_name()), 1)
            ], 42, _hoisted_3))
          }), 128))
        ], 512), [
          [_vShow, expanded.value]
        ])
      ], 4))
    : _createCommentVNode("", true)
}
}

})